import { ReactNode, useEffect } from 'react'

import { Button, Grid, Row, Span } from 'components'
import { ExpandIcon } from 'components/Icons'
import useToggle from 'hooks/useToggle'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

import {
  CardContentStyled,
  CardStyled,
  CollapseInfo,
  CollapseStyled
} from './styles'

export interface ICollpaseObj {
  code: string
  empresa: string
  dataIni: string
  dataFim: string
  titleCollapse: string
  dataUpdate?: string
  qtdDias?: number
}

interface CollpaseSearchProps {
  data: ICollpaseObj
  callBack?: any
  children: ReactNode
  hideButton?: boolean
  txtButton?: string
  isExpanded?: boolean
}

export const CollapseSearch = ({
  data,
  children,
  callBack,
  txtButton,
  isExpanded,
  hideButton = false
}: CollpaseSearchProps) => {
  const [expanded, toggleExpand] = useToggle(true)

  const showDate = (date: string): string => {
    const [_day, _month, year] = date.split('/')

    if (year === '0001') {
      return '----------'
    }

    return date
  }

  // useEffect(() => {
  //   if (isExpanded) {
  //     toggleExpand()
  //   }
  // }, [isExpanded])

  return (
    <CardStyled elevation={3}>
      <CardContentStyled isHeader>
        <CollapseInfo>
          <Grid
            gridCols={
              hideButton ? '2fr 2fr 4fr 0.2fr' : '2fr 2fr 3fr 3fr 0.2fr'
            }
            gridGap="0.5625rem"
          >
            <Span
              text={data.code}
              color={COLORS.blueFonts}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Span
              text={data.empresa}
              color={COLORS.black}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Row>
              <Span
                text={`Ini.`}
                marginRight={SPACING.spacing5}
                color={COLORS.blueFonts}
                fontWeight={FONTS.bold}
                fontSize={TYPOGRAPHY.bodySize16}
              />
              <Span
                text={`${showDate(data.dataIni)} -`}
                color={COLORS.black}
                fontWeight={FONTS.bold}
                fontSize={TYPOGRAPHY.bodySize16}
              />
              <Span
                text={`Fim`}
                marginLeft={SPACING.spacing5}
                marginRight={SPACING.spacing5}
                color={COLORS.blueFonts}
                fontWeight={FONTS.bold}
                fontSize={TYPOGRAPHY.bodySize16}
              />
              <Span
                text={`${showDate(data.dataFim)}`}
                color={COLORS.black}
                fontWeight={FONTS.bold}
                fontSize={TYPOGRAPHY.bodySize16}
              />
            </Row>

            {!hideButton && (
              <Button
                backgroundColor={COLORS.primary}
                text={txtButton}
                onClick={callBack}
                hide={hideButton}
                width="225px"
                marginTop="-6px"
                marginBottom="1px"
                boxShadow="none"
              />
            )}

            <ExpandIcon isExpanded={!expanded} onClick={toggleExpand} />
          </Grid>
          <Grid gridCols="2.4fr 0.75fr 0.3fr" gridGap="0.5625rem">
            <Span
              text={`${data.titleCollapse}`}
              color={COLORS.black}
              fontWeight={FONTS.regular}
              fontSize={TYPOGRAPHY.bodySize16}
            />

            {data.dataUpdate && (
              <Span
                text={`Dt.Ult.Atualização: ${data.dataUpdate}`}
                color={COLORS.black}
                fontWeight={FONTS.regular}
                fontSize={TYPOGRAPHY.bodySize16}
              />
            )}

            {data.qtdDias >= 0 && (
              <Span
                text={`Qtd.Dias: ${data.qtdDias}`}
                color={COLORS.black}
                fontWeight={FONTS.regular}
                fontSize={TYPOGRAPHY.bodySize16}
              />
            )}
          </Grid>
        </CollapseInfo>
      </CardContentStyled>
      <CollapseStyled in={expanded} timeout="auto" unmountOnExit>
        <CardContentStyled>{children}</CardContentStyled>
      </CollapseStyled>
    </CardStyled>
  )
}
